<template>
    <div class="t-container article">
      <div style="text-align: center; font-size: 35px; color: rgb(199 0 11); font-weight: 600; padding-top: 20px;"><span>{{ $i18n.t(`aboutHWT.five.content1`) }}</span></div>
      <p class="text article-content">{{ $i18n.t(`aboutHWT.five.content2`) }}</p>
      <p class="text article-content">{{ $i18n.t(`aboutHWT.five.content3`) }}</p>
      <p class="text article-content">{{ $i18n.t(`aboutHWT.five.content4`) }}</p>
      <p class="text article-content">{{ $i18n.t(`aboutHWT.five.content5`) }}</p>
      <img src="https://resources.holowits.com.sg/about/quality1.png" alt="" style="width: 100%; margin-top: 50px; padding: 0 100px;">
    </div>
  </template>
  
  <script>
  export default {
  name: 'CultureAndValue',
  data() {
      return {}
  }
  }
  </script>
  
  <style lang="less" scoped>
  .text {
      margin-top: 30px;
      font-size: 16px;
      font-weight: 500;
  }
  .article {
    padding: 0 24px 16px;
  
      .article-title {
      font-size: 40px;
      font-weight: 400;
      color: #000000;
      text-align: center;
      padding: 50px 0 40px;
      span {
          // border-bottom: 2px solid rgb(199 0 11);
          display: block;
          font-size: 28px;
          font-weight: 600;
      }
      }
  
      .article-content {
      font-size: 20px;
      font-weight: 400;
      color: #333333;
      line-height: 2.0;
      }
  }
  </style>